import { connect } from 'react-redux';

import Component from './EditCustomer';

const mapStateToProps = (state, props) => {
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Component);
